import { useState } from 'react'
import classNames from 'classnames'
import MembersTab from './members'
import TransactionsTab from './transactions'
import WinnersTab from './winners'

type TabKey = 'members' | 'transactions' | 'winners'

const TABS: Array<{ key: TabKey; label: string }> = [
    { key: 'members', label: 'اعضا' },
    { key: 'transactions', label: 'تراکنش‌ها' },
    { key: 'winners', label: 'برندگان' },
]

export default function CashboxTabs({
    id,
    cashbox,
}: {
    id?: string
    cashbox: ICashboxDetail
}) {
    const [active, setActive] = useState<TabKey>('members')
    const [search, setSearch] = useState('')

    return (
        <div className="bg-[#FAFAFA] min-h-[50vh]">
            <div className="sticky top-0 z-10 bg-white border-b border-divider">
                <div className="flex">
                    {TABS.map((tab) => (
                        <button
                            key={tab.key}
                            type="button"
                            onClick={() => {
                                setActive(tab.key)
                                setSearch('')
                            }}
                            className={classNames(
                                'flex-1 h-12 text-sm transition-colors',
                                active === tab.key
                                    ? 'text-green-1 font-bold border-b-2 border-green-1'
                                    : 'text-text-secondary border-b-2 border-transparent'
                            )}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>

            <div className="px-4 pt-3">
                <input
                    value={search}
                    onChange={(event) => setSearch(event.target.value)}
                    placeholder="جستجو…"
                    className="w-full h-10 rounded-[10px] border border-divider bg-white px-3 text-sm outline-none focus:border-green-1"
                />
            </div>

            {active === 'members' && (
                <MembersTab id={id} cashbox={cashbox} search={search} />
            )}
            {active === 'transactions' && (
                <TransactionsTab id={id} search={search} />
            )}
            {active === 'winners' && (
                <WinnersTab id={id} cashbox={cashbox} search={search} />
            )}
        </div>
    )
}
